import { graphql } from '@@fire-b2b/graphql/codegen'
import type { SeasonsQuery } from '@@fire-b2b/graphql/codegen/graphql'
import { gqlExecute, type GQLResult } from '@fire-b2b/utils/gql'

export type Season = SeasonsQuery['seasons']['results'][number]

export async function fetchSeasons(): Promise<GQLResult<Season[]>> {
  const result = await gqlExecute({
    query: graphql(`
      query Seasons($thumbnailWidth: Int!) {
        seasons {
          totalCount
          results {
            id
            seasonId
            ident
            title
            description
            sortOrder
            status
            thumbnail: medias(targetAttr: "image") {
              thumbnail(width: $thumbnailWidth)
            }
          }
        }
      }
    `),
    variables: {
      thumbnailWidth: useThumbnailSize('200x'),
    },
  })

  if (isErr(result)) {
    return result
  }

  const seasons = result.data.seasons.results
    .filter((s) => {
      return s.status === 1
    })
    .sort((a, b) => {
      return (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
    })

  return ok(seasons)
}
